<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0 bg-logo"
        style="background-color:#3f3939"
      >
        <!-- <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="logo"
          />
        </div> -->
      </b-col>

      <b-col
        lg="4"
        class="d-flex align-items-end auth-bg px-2 p-lg-5 justify-content-center"
      >
        <b-row style="height: 75%; justify-content: space-between;">
          <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
          >
            <div style="display: flex">
              <b-card-title
                title-tag="h2"
                class="font-weight-bold mb-1"
              >
                Alteração de senha
              </b-card-title>
              <manual-cliente
                tooltip
                style="margin-left: 2px;"
              />
            </div>
            <b-card-text class="mb-2">
              Por favor, altere sua senha
            </b-card-text>

            <!-- form -->
            <validation-observer ref="validacao">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
              >
                <!-- email -->
                <b-form-group
                  label="E-mail"
                  label-for="login-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="form.login"
                      disabled=""
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      placeholder="pessoa@auditarcontabilidade.com.br"
                    />
                    <small class="text-danger">{{ errors.length > 0 ? 'Informe o e-mail' : null }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-new-password">Nova senha</label>
                  </div>
                  <senha-input
                    v-model="form.novaSenha"
                    required
                    :auto-complete-senha="'new-password'"
                    :validacao-nome="'Nova senha'"
                  />
                </b-form-group>

                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-confirm-password">Confirmar senha</label>
                  </div>
                  <senha-input
                    v-model="form.confirmarSenha"
                    required
                    :validacao-nome="'Confirmar senha'"
                  />
                  <small class="text-danger">{{ loginError }}</small>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  @click="autenticar"
                >
                  Entrar
                </b-button>
                <div style="padding-top: 10px;">
                  <span>
                    *Padrão de senha esperado: deve conter no mínimo 8 caracteres, letras minúsculas, maiúsculas, símbolos e números.
                  </span>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col style="display: flex; flex-direction: column; justify-content: end;">
            <manual-cliente />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import useJwt from '@/auth/jwt/useJwt'
import { clearLoggedIn } from '@/auth/utils'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
    ManualCliente: () => import('@/app-modulo/comuns/manual-cliente/ManualCliente.vue'),
  },
  data() {
    return {
      form: {
        login: this.$route.query.email,
        token: this.$route.query.token,
        novaSenha: '',
        confirmarSenha: '',
        esqueciSenha: true,
      },
      loginError: '',
      logo: require('@/assets/images/logo/logocompleta.png'),
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      return require('@/assets/images/pages/logininterno.png')
    },
  },
  created() {
    clearLoggedIn()
  },
  methods: {
    autenticar() {
      this.loginError = ''
      this.$refs.validacao.validate()
        .then(() => {
          this.form.login = this.form.login.trim()
          useJwt.alterarSenha(this.form)
            .then(response => {
              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))

              this.$router.push({ name: 'portaldocumentos-externo' })
            })
            .catch(error => {
              this.loginError = error.response.data.message
              this.$refs.validacao.setErrors({ Password: error.response.data.message })
            })
        })
    },
  },
}
</script>
